<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left" style="padding-top: 20px;">
              <div style="float:right;margin-right:50px;">
                <i class="el-icon-question"></i>如何填写？
                <a
                  href="javascript:;"
                  style="color:#b60205;text-decoration:underline"
                  @click="helpMe"
                >查看示意图</a>
              </div>

              <el-dialog
                :visible.sync="help_show"
                width="80%"
                append-to-body
                :title="active == 1?`公益${$route.query.type == 2?'自有':'合作'}项目申请第一步示意图`:`公益${$route.query.type == 2?'自有':'合作'}项目申请第二步示意图`"
              >
                <template v-if="$route.query.type == 2">
                  <img
                    width="100%"
                    src="../../../../assets/images/compro_help1.png"
                    v-if="active == 1"
                    alt
                  />
                  <img
                    width="100%"
                    src="../../../../assets/images/compro_help2.png"
                    v-if="active == 2"
                    alt
                  />
                </template>

                <template v-if="$route.query.type == 1">
                  <img
                    width="100%"
                    src="../../../../assets/images/compro_help3.png"
                    v-if="active == 1"
                    alt
                  />
                  <img
                    width="100%"
                    src="../../../../assets/images/compro_help4.png"
                    v-if="active == 2"
                    alt
                  />
                </template>
              </el-dialog>
              <div
                style="font-size:28px;margin-bottom:20px;margin-left:20px"
              >公益{{$route.query.type == 2?'自有':'合作'}}项目申请</div>

              <div style="width:90%;margin:10px auto;">
                <el-steps :active="active" simple>
                  <el-step :title="stepTitle" description="基础信息" icon="el-icon-edit"></el-step>
                  <el-step title="扩展信息" description="扩展信息" icon="el-icon-edit"></el-step>
                </el-steps>
              </div>

              <div v-show="active == 1">
                <first
                  ref="firstRef"
                  @callback="callback"
                  :id="id"
                  v-if="$route.query.type == 1"
                  :data.sync="formData"
                ></first>
                <!-- 自有项目信息 start -->
                <first1
                  ref="firstRef"
                  @callback="callback"
                  :id="id"
                  v-if="$route.query.type == 2"
                  :data.sync="formData"
                ></first1>
                <!-- 自有项目信息 end -->
              </div>

              <div v-show="active == 2">
                <second ref="secondRef" v-if="id>0" :id="id" :data.sync="formData"></second>
              </div>
              <!-- </el-form> -->

              <div style="float:right;margin-right:50px">
                <el-button
                  type="danger"
                  style="margin-top: 20px; margin-bottom: 20px;"
                  size="small"
                  @click="goBack()"
                  icon="el-icon-close"
                  v-if="active == 1"
                >关闭</el-button>

                <el-button
                  type="primary"
                  style="margin-top: 20px; margin-bottom: 20px;"
                  size="small"
                  @click="onSubmit"
                  v-if="active == 1"
                >
                  下一步
                  <i class="el-icon-right"></i>
                </el-button>

                <el-button
                  style="margin-top: 20px; margin-bottom: 20px;"
                  size="small"
                  icon="el-icon-back"
                  @click="prev"
                  v-if="active == 2"
                >上一步</el-button>

                <el-button
                  type="primary"
                  style="margin-top: 20px; margin-bottom: 20px;"
                  size="small"
                  v-if="active == 2"
                  icon="el-icon-finished"
                  @click="onSave"
                >保存</el-button>

                <el-button
                  type="primary"
                  style="margin-top: 20px; margin-bottom: 20px;"
                  size="small"
                  icon="el-icon-s-promotion"
                  v-if="active == 2"
                  @click="onSubmit"
                >提交</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import baseUrl from "@/config/index";
import first from "./step/first";
import first1 from "./step/first1";
import second from "./step/second";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    second,
    first,
    first1
  },
  data() {
    return {
      help_show: false,
      help_url: null,
      id: null, //立项id
      uploadFileUrl: "", //上传文件接口url
      active: 1, //当前页
      stepTitle: "自有项目信息",
      flag: true,
      firstEditInfo: {}, //第一步编辑数据
      formData: {}
    };
  },
  methods: {
    //回到列表
    goBack() {
      this.$confirm("此操作将回到列表页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$router.push({ name: "hospitalBuildList" });
        })
        .catch(() => {});
    },

    //点击下一步提交操作
    onSubmit() {
      if (this.active == 1) {
        this.$refs.firstRef.submitF();
      } else if (this.active == 2) {
        //新增
        this.$refs.secondRef.submitF();
      }
    },

    //处理编辑数据
    getEditInfo() {
      this.$db
        .post(this.$db.config.com_project.approval.detail, {
          id: this.$route.query.id
        })
        .then(res => {
          if (res && res.code == 200) {
            this.formData = res.data;

            this.formData.collaborator_name =
              res.data.finance.collaborator_name;
            this.formData.corporation = res.data.finance.corporation;
            this.formData.contacts = res.data.finance.contacts;
            this.formData.payee_unit_name = res.data.finance.payee_unit_name;
            this.formData.payee_rela_user_name =
              res.data.finance.payee_rela_user_name;
            this.formData.payee_office_phone =
              res.data.finance.payee_office_phone;
            this.formData.bank_name = res.data.finance.bank_name;
            this.formData.account_name = res.data.finance.account_name;
            this.formData.account_number = res.data.finance.account_number;
            this.formData.business_scope = res.data.finance.business_scope;
          }
        });
    },

    //保存草稿
    onSave() {
      if (this.active == 2) {
        this.$refs.secondRef.onSave();
      }
    },

    //第一步回调
    callback(data) {
      if (this.active == 1) {
        this.id = parseInt(data[0]);
        this.active++;
      }
    },

    //上一步操作
    prev() {
      this.active = this.active - 1;
    },

    //示意图操作
    helpMe() {
      this.help_show = true;
    }
  },

  created() {
    //立项基础信息
    if (this.$route.query.type) {
      this.$route.query.type == 1
        ? (this.stepTitle = "合作项目信息")
        : (this.stepTitle = "自有项目信息");
    } else {
      this.$router.push({ name: "hospitalBuildList" });
    }

    if (this.$route.query.id) {
      this.getEditInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 14px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
}

.nomaltr /deep/ td {
  border-bottom: none !important;
}
.nomaltr /deep/ .el-form-item {
  margin-bottom: 0;
}
.center-list /deep/ .el-dialog__title {
  font-weight: 600;
}
.center-list /deep/ .el-dialog__body {
  padding: 20px;
}
.table /deep/ .el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
.nomaltr /deep/ .el-input-number.is-without-controls .el-input__inner {
  padding: 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Hospital/comproject/approval/info.vue